import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaHardHat } from 'react-icons/fa';

const NotFound = () => {
  return (
    <Container className="d-flex align-items-center justify-content-center">
      <div className="text-center p-5 wrapper shadow-lg">
        <IconWrapper>
          <FaHardHat className="text-white display-1" />
        </IconWrapper>
        <h1 className="display-1 fw-bold mt-4 error-code">404</h1>
        <h3 className="mb-3 text-dark fw-bold">Oops! We Hit a Roadblock.</h3>
        <p className="text-muted mb-4 lead">
          It looks like this page is still under construction or doesn't exist. Let's get you back on track!
        </p>
        <Link to="/" className="btn custom-btn rounded-pill px-5 py-3 fw-bold shadow">
          Go Back Home
        </Link>
      </div>
    </Container>
  );
};

export default NotFound;

const Container = styled.div`
  min-height: 80vh;
  background-color: #f8f9fa;
  
  .wrapper {
    background-color: white;
    border-radius: 20px;
    max-width: 600px;
    width: 90%;
    position: relative;
    overflow: hidden;
  }
  
  .wrapper::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 8px;
    background: repeating-linear-gradient(
      45deg,
      #f26a20,
      #f26a20 20px,
      #34495e 20px,
      #34495e 40px
    );
  }

  .error-code {
    color: #f26a20;
    text-shadow: 2px 2px 4px rgba(242, 106, 32, 0.3);
  }

  .custom-btn {
    background-color: #f26a20;
    color: white;
    transition: all 0.3s ease;
    border: none;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .custom-btn:hover {
    background-color: #34495e;
    color: white;
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(52, 73, 94, 0.3) !important;
  }
`;

const IconWrapper = styled.div`
  background: linear-gradient(135deg, #f26a20, #e65c00);
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  box-shadow: 0 10px 25px rgba(242, 106, 32, 0.4);
  animation: float 3s ease-in-out infinite;

  @keyframes float {
    0% { transform: translateY(0px); }
    50% { transform: translateY(-15px); }
    100% { transform: translateY(0px); }
  }
`;
